var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout-item carrus-page-content"},[_vm._v(" Learn ")])}
var staticRenderFns = []

export { render, staticRenderFns }